import { useState } from "react";
import { PlanningEvent } from "@ac-expo/ui-components";

export const useActivityDetails = () => {
  const [selectedActivities, setSelectedActivities] = useState<PlanningEvent[]>(
    []
  );

  const closeActivityList = () => {
    setSelectedActivities([]);
  };

  const openActivityList = (events: PlanningEvent[]) => {
    setSelectedActivities(events);
  };

  return {
    selectedActivities,
    closeActivityList,
    openActivityList,
  };
};
